// import { Database } from "@/service/database/databaseService";

const state = {
    boards: [],
}

const mutations = {

}

const actions = {

}

const namespaced = true;

const database = {
    state,
    mutations,
    actions,
    namespaced
}

export default database;

